import { storeRef } from "@/components/providers/StoreProvider"

export const getQueryStringTourDetail = (tour?: any, categoryId?: string) => {
  const params = new URLSearchParams()
  const tourCategories = storeRef.current?.getState().tour.tours_categories.data.tourCategories || []
  const tourCategory = tourCategories.find(t => t.id === categoryId)

  params.set("priceId", tour?.priceId || '')
  params.set("categoryId", categoryId || '')
  params.set("providerCode", tour?.providerCode || (tour as any)?.vendorCode || '')
  params.set("isDomestic", tour.isDomestic || (!!tourCategory && tourCategory.tourType === 'DOMESTIC') ? '1' : '2')

  return params.toString()
}